import axios from 'axios'

window.axios = axios
window.axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
